var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[_c('v-col',{attrs:{"md":"12"}},[_c('v-hover',{scopedSlots:_vm._u([{key:"default",fn:function({ hover }){return [_c('v-card',{staticClass:"mx-auto",attrs:{"elevation":hover ? 5 : 2}},[_c('v-card-text',[_vm._t("default")],2)],1)]}}],null,true)})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }